<mat-toolbar color="accent" class="logo-toolbar">
  <a [routerLink]="['/']">
    <img
      src="/assets/icons/principle-row-white.svg"
      onerror="this.src='/assets/icons/principle-row-white.png'"
      [ngClass]="{ expanded: sidebar.expanded$ | async }"
    />
  </a>
</mat-toolbar>

<div class="content scrollable flex-1">
  <ng-content />
</div>

<mat-toolbar
  color="accent"
  class="expand-button flex items-center"
  matRipple
  (click)="toggleExpanded()"
>
  @if (sidebar.expanded$ | async) {
    <pt-app-version class="opacity-30" />
    @if (sidebar.isDesktop$ | async) {
      <div class="flex-1"></div>
      <mat-icon>{{
        (sidebarClosedSet$ | async) ? 'chevron_right' : 'chevron_left'
      }}</mat-icon>
    }
  }
</mat-toolbar>
